export default __webpack_public_path__ + "static/media/background_contact.ac047bab.svg";